module.exports = __webpack_public_path__ + "img/customer_service.3ff750a8.png";